import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SnackBarUI from '../../comman/SnackBarUI'
import { deleteSupportDataAction } from '../../redux/toolkit/support/deleteData'
import { supportDataAction } from '../../redux/toolkit/support/list';
import PropTypes from 'prop-types';

export default function DeleteSupport({ cat_id, state, setState }) {
    // state
    const dispatch = useDispatch()
    const deleteSupport = useSelector(state => state.deleteSupport)
    const { status, message } = deleteSupport

    const [snack, setSnack] = useState(false)

    // fn
    const handleClose = () => {
        setState(false)

    }

    const delCatHandle = async () => {
        await dispatch(deleteSupportDataAction({id:cat_id,is_deleted:true}))
        await dispatch(supportDataAction({ is_deleted: false,page:0,limit:100}))
        setSnack(true)
        setState(false)
    }




    return (
        <>
            <Dialog open={state} onClose={handleClose}>
                <DialogTitle>Deleting request !</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete the selected item ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={delCatHandle} autoFocus> Agree</Button>
                    <Button onClick={handleClose}>Disagree</Button>
                </DialogActions>
            </Dialog>


            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
        </>

    )
}


DeleteSupport.propTypes = {
    qns_id: PropTypes.string,
    state: PropTypes.any,
    setState: PropTypes.any
};